import { render, staticRenderFns } from "./pushChannel__list.vue?vue&type=template&id=59d66d30"
import script from "./pushChannel__list.vue?vue&type=script&lang=js"
export * from "./pushChannel__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports